import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { parseAmount } from "@/lib/money";

// One money field, everywhere. inputMode="decimal" so iOS shows a keypad WITH
// the separator (a money field that opens the letter keyboard next to one that
// opens digits is its own bug), and the typed text is never rewritten: if it
// cannot be read as an amount the field says so when you leave it.
export const MoneyInput = ({ id, value, onChange, testid, disabled, placeholder = "0,00" }) => {
  const [error, setError] = useState(null);
  return (
    <>
      <Input
        id={id}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        data-testid={testid}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        aria-invalid={error ? "true" : undefined}
        className={error ? "border-fout-rand" : undefined}
        onChange={(e) => { onChange(e.target.value); if (error) setError(null); }}
        onBlur={(e) => setError(parseAmount(e.target.value).error)}
      />
      {error && (
        <p className="text-data text-fout-tekst" data-testid={testid ? `${testid}-error` : undefined}>
          {error}
        </p>
      )}
    </>
  );
};
